import Vue from 'vue'
const EventBus = new Vue()
export default ({ app }, inject) => {
  // Makes this.$bus available in all components
  inject('bus', EventBus)
}

